<template>
    <div id="debtNoteBalance">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                  <div class="page-title"> Debt Notes Balance Details</div>
                  <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                  <a href="javascript:void(0)" class="btn btn-secondary pull-right mr-2" v-on:click="exportReports()">
                      <i class="fp-export"></i> Export
                  </a>

                </div>


                <div class="container-fluid">
                    <div class="admin-page-content">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'debtNoteBalanceDetail'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange" :moduleName="'debtNoteBalanceDetail'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="debtNoteBalanceDetailTable"
                                      mode="remote"
                                      title="Debt Note Balance Detail"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'bottom',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <!-- <div slot="selected-row-actions">
                                          <button v-if="isActivateStatus" id="activeDebtNoteBtn" v-on:click.prevent="activateDebtNote" class="btn btn-primary">Active</button>
                                          <button id="deleteDebtNoteBtn" v-on:click.prevent="deleteDebtNote" class="btn btn-primary">Delete</button>
                                      </div> -->

                                  </vue-good-table>
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>


            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>

<script>

import Vue from 'vue';
import EventBus from "./event-bus";

import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

export default {
    name: "debtNoteList",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Debt Note Balance Detail | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
      isActivateStatus: false,
      permissions:[],
      cantAccessPage:'',
      canAddDebtNote:'',
      loading:false,
      userColumns: [],
      columns: [
          {
                label: 'Financier',
                field: 'vendor_code',
                fpFieldType:"text",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Asset", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Financier Description',
                field: 'vendor_name',
                fpFieldType:"text",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Asset", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Note Reference',
                field: 'reference_number',
                fpFieldType:"text",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Reference Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Note Balance',
                field: 'current_balance',
                fpFieldType:"integer",
                type:"number",
                thClass: "text-Right", //this.alignment,
                html: true,
                filterable: false,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Note Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label: 'Original Loan Amt',
                field: 'note_amount',
                fpFieldType:"integer",
                type:"number",
                thClass: "text-Right", //this.alignment,
                html: true,
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Note Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Interest Rate',
                field: 'interest',
                fpFieldType:"integer",
                type:"number",
                html: true,
                filterable: false,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label: 'Unit Number',
                field: 'unit_number',
                fpFieldType:"text",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Unit Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Unit Pool',
                field: 'pool',
                fpFieldType:"option",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "pool", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Note Percent',
                field: 'note_percent',
                fpFieldType:"integer",
                type:"number",
                filterable: false,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Unit Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
             {
                label: 'Unit Balance',
                field: 'current_balance',
                fpFieldType:"integer",
                type:"number",
                filterable: false,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Unit Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label: 'Sched Sts',
                field: 'status',
                fpFieldType:"option",
                hidden:false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter", //only trigger on enter not on keyup
                    filterDropdownItems:["E","A","C"]
                }
              },
              {
                label: 'Payment Type',
                field: 'payment_type',
                fpFieldType:"option",
                hidden:false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter", //only trigger on enter not on keyup
                    filterDropdownItems:["F","B","V"]
                }
              },
              {
                label: 'Customer Number',
                field: 'cust_code',
                fpFieldType:"text",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Customer Name',
                field: 'cust_name',
                fpFieldType:"text",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Unit Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Start Date',
                field: 'financing_start_date',
                fpFieldType:"date",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Start Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
             {
                label: 'Original Payout Date',
                field: 'end_date',
                fpFieldType:"date",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Start Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Original Duration',
                field: 'duration',
                fpFieldType:"integer",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Duration", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Scheduled Payout Date',
                field: 'sch_end_date',
                fpFieldType:"date",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Start Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Nbr Of Scheduled Payments',
                field: 'sc_duration',
                fpFieldType:"integer",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Duration", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Payments To Date',
                field: 'current_duration',
                fpFieldType:"integer",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Duration", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Remaining Payments',
                field: 'remaining_duration',
                fpFieldType:"integer",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Duration", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Payment Amount',
                field: 'principal_payment',
                fpFieldType:"integer",
                type:"number",
                html: true,
                filterable: false,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label: 'Residual',
                field: 'residual',
                fpFieldType:"integer",
                type:"number",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Vin (Last 6)',
                field: 'vin',
                fpFieldType:"text",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'As Of Date',
                field: 'as_at_date',
                filterable: false,
                hidden:true,
                fpFieldType:"custom_date",
            },
      ],
      rows: [],
      totalRecords: 0,
      pageKey:"_debt_note_list_",
      batchProcess:0,
      batchNum:"",
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'debt_note_balance_report') {
                    self.cantAccessPage = true;
                }
                // if(permissions.name == 'add_debt_note') {
                //     self.canAddDebtNote = true;
                // }
            });
        }
    },
    created: function() {
    },
    mounted: function () {

        this.getPermissions();

    },
    methods: {

      cancelAll: function (cancelAll) {
        this.$refs.debtNoteBalanceDetailTable.unselectAllInternal();
      },

      loadList() {

          var self = this;
          self.loading = true;
          var data = this.$refs['debtNoteBalanceDetailTable'].selectedRows;
          var selectedRows = [];

          for (var i = 0; i < data.length; i++) {
              selectedRows.push(self.$refs['debtNoteBalanceDetailTable'].selectedRows[i].id)
          }
          var fields = {
              page: self.serverParams.page,
              perPage: self.serverParams.perPage,
              filters: self.serverParams.columnFilters,
              sort: self.serverParams.sort,
              all:self.serverParams.selectedAll,
              selectedRows:selectedRows,
              action:self.action,
          };
          self.firstLoad = 1;
          $.ajax({
              url: process.env.ROOT_API + "/debtnote-balance/list",
              type: "POST",
              data: fields,
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  // console.log(data);
                  if (data.status == "success") {
                      if ( self.action == "export" ||  self.action == "export_queue") {
                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {
                              if ( self.action == "export" ) {
                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);

                              } else {

                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                              }
                          }
                          self.action = "list";
                          // self.loadList();
                      } else{
                        console.log(data.content.row);
                          self.rows = data.content.row;
                          self.totalRecords = data.content.totalRecords;
                          self.filteredFlag = false;
                      }
                  }else{
                      self.rows = data.content.row;
                      self.totalRecords = data.content.totalRecords;
                      self.filteredFlag = false;
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  if ( self.action == "delete" ) {
                      self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-delete')
                  }else{
                      self.generateStatusCodeMessage(jqXHR,false,'rental-agreement-list')
                  }

              }
          });

      },
    },
}
</script>





// WEBPACK FOOTER //
// src/components/DebtNoteBalanceReport.vue